<template>
  <div class="lotteryComp">
    <LuckyCardLottery
      v-bind="$attrs"
      v-on="$listeners"
      @reportDraw="handleReportDraw"
    />
  </div>
</template>

<script>
import LuckyCardLottery from '@/components/templates/common/LuckyCardLottery';
export default {
  components: { LuckyCardLottery },
  mounted() {
    this.$emit('reportEvent', {
      event: 'lottery_topic_expo',
      module_name: '1003'
    });
  },
  methods: {
    handleReportDraw({ is_success }) {
      this.$emit('reportEvent', {
        event: 'lottery_button_click',
        module_name: '1003',
        button_name: '翻牌子_翻',
        is_success
      });
    }
  }
};
</script>

<style>
.lotteryComp {
  padding-top: 242px;
  padding-bottom: 52px;
}
</style>
